<template>
    <div>
        <trip-preferences/>
    </div>
</template>

<script>

    import TripPreferences from "../../components/TripPreferences.vue";

    export default {
        components: {TripPreferences}
        // NOTE: no data() here on purpose. An empty `data: function() {}` returns
        // undefined, which leaves vm._data undefined; Vue 2's $destroy then throws
        // on `vm._data.__ob__` when this route component is torn down (navigating
        // away from Trip Preferences), killing the patch mid-flight and blanking
        // the app. If state is ever needed here, it MUST return an object.
    };
</script>

<style lang="scss" scoped>

</style>
